export const WeeklyPlanData = [
  {
    path: "https://drive.google.com/file/d/1KVQ0h-vHnMiGEsZ70fbHMePN8Ug3MPrm/view",
    title: `Week 1`,
    weekNumber: '1',
    thumbnail: 'https://lh3.googleusercontent.com/d/14bPgOC1T-_618ptBhzCMK6ymGGCHU83m=s1000?authuser=0'
  },
  {
    path: "https://drive.google.com/file/d/1tOMDVBfBXWIe-B3CoW0HQFDVixnL1_Yl/view",
    title: `Week 2`,
    weekNumber: '2',
    thumbnail: 'https://lh3.googleusercontent.com/d/1WJzQrpGZbp_FjTLdw7c771EngYYD867l=s1000?authuser=0'
  },
  {
    path: "https://drive.google.com/file/d/1YsCXmEuacGaIgqnXf7inVOpsx4ucK6zP/view",
    title: `Week 3`,
    weekNumber: '3',
    thumbnail: 'https://lh3.googleusercontent.com/d/1cK8qOUp8wyr1Kx8bnv16a9cVZiuOBjpI=s1000?authuser=0'
  },
  {
    path: "https://drive.google.com/file/d/1jL-LB7nGyD-8b3pFgKfViGRZ-nqgVOt7/view",
    title: `Week 4`,
    weekNumber: '4',
    thumbnail: 'https://lh3.googleusercontent.com/d/1d0moiUl2IYsA3IrSFKB929_YgR1wmXGl=s1000?authuser=0'
  },
  {
    path: "https://drive.google.com/file/d/1-_X1zMMJnauX8s_LT_mA3-sfWVOSF7pd/view",
    title: `Week 5`,
    weekNumber: '5',
    thumbnail: 'https://lh3.googleusercontent.com/d/1Lcj-SaArhspq7sgNtF5t3PsmWq9d8uv6=s1000?authuser=0'
  },
  {
    path: "https://drive.google.com/file/d/1N-aIvnAt5Aj1FF2CXkD2VGaDX7pAEALr/view",
    title: `Week 6`,
    weekNumber: '6',
    thumbnail: 'https://lh3.googleusercontent.com/d/1SbPf7TzIplzLhNuKvf4LVR_BOqO9MYwU=s1000?authuser=0'
  },
  {
    path: "https://drive.google.com/file/d/1-_VhEGNP5IqXkcke18aNi8m5yexBgQtW/view",
    title: `Week 7`,
    weekNumber: '7',
    thumbnail: 'https://lh3.googleusercontent.com/d/1sKpvenSDekhYTolcAXOQSm6t7Jj20Tgq=s1000?authuser=0'
  },
  {
    path: "https://drive.google.com/file/d/1MnF_Tqi8X22D-HWhC1nQHbnbFs5N68Fl/view",
    title: `Week 8`,
    weekNumber: '8',
    thumbnail: 'https://lh3.googleusercontent.com/d/10K7gs93uHfM2Iw7GdekN0JM86Ci6RKG6=s1000?authuser=0'
  },
  {
    path: "https://drive.google.com/file/d/13slnRCfILrO3E7uZQ-BRK2IaT_0LFddh/view",
    title: `Week 9`,
    weekNumber: '9',
    thumbnail: 'https://lh3.googleusercontent.com/d/1ElvjZVGT88gv8XFtgQNi0vIUlydjYI-n=s1000?authuser=0'
  },
  {
    path: "https://drive.google.com/file/d/1bDmiARGcHRVmnoiKq5FW0fwuiJpSCg2U/view",
    title: `Week 10`,
    weekNumber: '10',
    thumbnail: 'https://lh3.googleusercontent.com/d/1TwbfetJl6N4Y7V94bv3P2Z7byHVdDG8g=s1000?authuser=0'
  },
  {
    path: "https://drive.google.com/file/d/1P8GbRmOnV3UxxzqXUMyU-fbK2Fh0wePX/view",
    title: `Week 11`,
    weekNumber: '11',
    thumbnail: 'https://lh3.googleusercontent.com/d/14Jav4EhEYKk7NgJ5QwhVc3GwMrAIkBQ8=s1000?authuser=0'
  },
  {
    path: "https://drive.google.com/file/d/1WNTigSBUOPrM9Eh5JOCeZpyxqR2AqlTS/view",
    title: `Week 12`,
    weekNumber: '12',
    thumbnail: 'https://lh3.googleusercontent.com/d/1Rwz0HJxI3JZBQa9_whwR1n7CV7pV3sC9=s1000?authuser=0'
  },
  {
    path: "https://drive.google.com/file/d/1cmdsBbuDstVECUrQKGBCPQEeEiuX32mE/view",
    title: `Week 13`,
    weekNumber: '13',
    thumbnail: 'https://lh3.googleusercontent.com/d/1S6j2t41_Q7hDTltLohuJ6wAS7rCDfbvQ=s1000?authuser=0'
  },
  {
    path: "https://drive.google.com/file/d/1Lv4d6nMunq7eLabvNUDqdPcCq5CjmtLc/view",
    title: `Week 14`,
    weekNumber: '14',
    thumbnail: 'https://lh3.googleusercontent.com/d/1st4rfJgIBsrp4NDK960dyo_8mpbPlwEB=s1000?authuser=0'
  },
  {
    path: "https://drive.google.com/file/d/1GXW2exe5xX-y6kp2mKhdIJ1_Vi0gB_9u/view",
    title: `Week 15`,
    weekNumber: '15',
    thumbnail: 'https://lh3.googleusercontent.com/d/1GiMhcqwheoEvcAhjF2GgyDKBc6qrv1FD=s1000?authuser=0'
  },
  {
    path: "https://drive.google.com/file/d/1NfLT-b1yAGqWSOjfeCoZ2ZzFa4D8oxaO/view",
    title: `Week 16`,
    weekNumber: '16',
    thumbnail: 'https://lh3.googleusercontent.com/d/1KvcD7IW7wnoeyAQLFMs4kfW4Dsw46PlZ=s1000?authuser=0'
  },
  {
    path: "https://drive.google.com/file/d/1XRshXD3XDRReREcpwdW4GpG-I8Rzqo1F/view",
    title: `Week 17`,
    weekNumber: '17',
    thumbnail: 'https://lh3.googleusercontent.com/d/1SqvvWn2gmZ-dZgXDcnLz5xkIWDy0ZnB1=s1000?authuser=0'
  },
  {
    path: "https://drive.google.com/file/d/1sjV9fpefa5i3mgnjFCuSq-kQsioO0Zi8/view",
    title: `Week 18`,
    weekNumber: '18',
    thumbnail: 'https://lh3.googleusercontent.com/d/1c_ZQUkskUNinH2A4LPrvxIJQFdmD13LG=s1000?authuser=0'
  },
  {
    path: "https://drive.google.com/file/d/1dQR_kEOLlqowkm5VRfGwpyMoqoke3xNx/view",
    title: `Week 19`,
    weekNumber: '19',
    thumbnail: 'https://lh3.googleusercontent.com/d/1oK1m63SnE-CMw-QF6ZnO6rf5ySzjbsmb=s1000?authuser=0'
  },
  {
    path: "https://drive.google.com/file/d/1i7a4lWuCEgmN63T0Vv6aerb3_WUCGROX/view",
    title: `Week 20`,
    weekNumber: '20',
    thumbnail: 'https://lh3.googleusercontent.com/d/1s4gCuEgraQAFwpNM70yR34Ovw-TOtaAi=s1000?authuser=0'
  },
  {
    path: "https://drive.google.com/file/d/1w-OHjNovhU-Zf_Z50ulbvsc7dZ86g8D1/view",
    title: `Week 21`,
    weekNumber: '21',
    thumbnail: 'https://lh3.googleusercontent.com/d/100jKV2crQ6KNXyn21r_W_MAufgf8g2p8=s1000?authuser=0'
  },
  {
    path: "https://drive.google.com/file/d/1jamSdbtvNvgEc-iMw5UXWqBEL0bR6ikA/view",
    title: `Week 22`,
    weekNumber: '22',
    thumbnail: 'https://lh3.googleusercontent.com/d/1fhhIfyE47lQDrXbc5gAbHcJ31PlED7gk=s1000?authuser=0'
  },
  {
    path: "https://drive.google.com/file/d/1NEDbqPWabFtlgyA9Z4-IhpBdl8Qqk9Kg/view",
    title: `Week 23`,
    weekNumber: '23',
    thumbnail: 'https://lh3.googleusercontent.com/d/1MB-4q3ArxFj6MY3Lj-Xc11sRQZ1E-WH5=s1000?authuser=0'
  },
  {
    path: "https://drive.google.com/file/d/19lrOYxjNZ588Ag-vVeeyCRreUERsL3gU/view",
    title: `Week 24`,
    weekNumber: '24',
    thumbnail: 'https://lh3.googleusercontent.com/d/1R0Yo9HJVzLW1WR9kPtBbK8r5yHDZg0U-=s1000?authuser=0'
  },
  {
    path: "https://drive.google.com/file/d/1amPJnd09SKXQfgDDlcD27obC2fVw5V5N/view",
    title: `Week 25`,
    weekNumber: '25',
    thumbnail: 'https://lh3.googleusercontent.com/d/1jP2SVhlCsBTOFLAhB9tHKFvmY5gQv8OR=s1000?authuser=0'
  },
  {
    path: "https://drive.google.com/file/d/1KwsEw2z7SvQTs26wAf3MzpWyZbiEXzmv/view",
    title: `Week 26`,
    weekNumber: '26',
    thumbnail: 'https://lh3.googleusercontent.com/d/1xnLhCQIQVpq07ZKEACwYnJ_zv2jXJqs3=s1000?authuser=0'
  },
  {
    path: "https://drive.google.com/file/d/1OVmkHb8GZnqtAiIU7f-jsy2d805tiIuA/view",
    title: `Week 27`,
    weekNumber: '27',
    thumbnail: 'https://lh3.googleusercontent.com/d/1wI-j-d3aVrXrJEWiXGRWS1LHYe8hcs8o=s1000?authuser=0'
  },
  {
    path: "https://drive.google.com/file/d/1PMcfHq_bIU7-JRlv5g2nuHsx1t3FQT7E/view",
    title: `Week 28`,
    weekNumber: '28',
    thumbnail: 'https://lh3.googleusercontent.com/d/1l1Bsw0DUO87ld_y4eaZ9IWEm8T3CW8W3=s1000?authuser=0'
  },
  {
    path: "https://drive.google.com/file/d/1T8Hl9eQfWZAeilIfcRE-fio0YNl3rFfZ/view",
    title: `Week 29`,
    weekNumber: '29',
    thumbnail: 'https://lh3.googleusercontent.com/d/1t3MTSMiFAP_KyRu2livEQbx_taLQJELm=s1000?authuser=0'
  },
  {
    path: "https://drive.google.com/file/d/1Wa9lEdDdictjrTErYkmD6UKmJ_uzm3bj/view",
    title: `Week 30`,
    weekNumber: '30',
    thumbnail: 'https://lh3.googleusercontent.com/d/1h5hDxCSa__DtYge7kEpZcdaSQk9_g4dH=s1000?authuser=0'
  },
  {
    path: "https://drive.google.com/file/d/17L9xuHdWrBx2A0d5P3dm_gnbbFPW1C8E/view",
    title: `Week 31`,
    weekNumber: '31',
    thumbnail: 'https://lh3.googleusercontent.com/d/1Ncz4dyzC-u5cOhLu1NZV_C7R_u7adBru=s1000?authuser=0'
  },
  {
    path: "https://drive.google.com/file/d/11erQoHYnHfmj8WtG37q8YOYsp_Nt_R7A/view",
    title: `Week 32`,
    weekNumber: '32',
    thumbnail: 'https://lh3.googleusercontent.com/d/1iPc4nA6U6iw5zkhh8Dc8cYwOu2DnXLWj=s1000?authuser=0'
  },
   {
    path: "https://drive.google.com/file/d/1ht-8Vo9VGq3okF1GDesbmY5Qx1tDyNcl/view",
    title: `Week 33`,
    weekNumber: '33',
    thumbnail: 'https://lh3.googleusercontent.com/d/1d4u91oq7Ds4RDdwPr6EZw200P9tAUkoC=s1000?authuser=0'
  }
]